<template>
  <caddie-income-attend-status :is-income-page="false"/>
</template>

<script>
import CaddieIncomeAttendStatus from '@/views/game-progress/caddie-arrangement/CaddieIncomeAttendStatus';

export default {
  name: 'CaddieAttendStatus',
  components: {CaddieIncomeAttendStatus},
};
</script>
